export default __webpack_public_path__ + "static/media/voucherAddition3.0f39d137.jpg";